import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import HelpArticleLink from '../../components/help-article-link';
import { linkIDs } from '../../services/link-service/links';
import { MAX_CHAR_COUNT } from './package-content-description';
import { messages } from './messages';
import style from './package-content-description.module.less';

const ValidationMessage = ({ remainingCount, showCount = false, showError = false }) => {
  if (showError) {
    return (
      <InlineMessage type={INLINE_MESSAGE_TYPES.error}>
        <FormattedMessage
          {...messages.required}
          values={{
            a: (chunks) => <HelpArticleLink articleId={linkIDs.MexicanPackageContentDescription}>{chunks}</HelpArticleLink>,
          }}
        />
      </InlineMessage>
    );
  }

  return (
    <div className={style['character-count']}>
      <FormattedMessage {...messages.characterMax} values={{ charMax: MAX_CHAR_COUNT }} />
      {showCount && (
        <span className={style['remaining-count']}>
          <FormattedMessage {...messages.charactersLeft} values={{ remainingCount }} />
        </span>
      )}
    </div>
  );
};

ValidationMessage.propTypes = {
  remainingCount: PropTypes.number.isRequired,
  showCount: PropTypes.bool,
  showError: PropTypes.bool,
};

export { ValidationMessage };
